import React, { useState, useEffect } from 'react';
import { Download, X } from 'lucide-react';

const InstallPrompt = () => {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showPrompt, setShowPrompt] = useState(false);
  const [isIOS, setIsIOS] = useState(false);

  useEffect(() => {
    // Detect iOS
    const ios = /iphone|ipad|ipod/.test(navigator.userAgent.toLowerCase());
    setIsIOS(ios);

    // Android/Desktop install prompt
    window.addEventListener('beforeinstallprompt', (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setShowPrompt(true);
    });
  }, []);

  const handleInstall = async () => {
    if (!deferredPrompt) return;
    deferredPrompt.prompt();
    const { outcome } = await deferredPrompt.userChoice;
    if (outcome === 'accepted') setShowPrompt(false);
    setDeferredPrompt(null);
  };

  if (!showPrompt && !isIOS) return null;

  return (
    <div className="fixed top-4 left-4 right-4 bg-brand-600 text-white rounded-xl p-4 shadow-xl z-50 flex items-center gap-3">
      <Download className="w-6 h-6 flex-shrink-0" />
      <div className="flex-1">
        <p className="font-bold text-sm">התקן את האפליקציה!</p>
        {isIOS ? (
          <p className="text-xs text-brand-100 mt-1">
            לחץ על 📤 ואז "הוסף למסך הבית"
          </p>
        ) : (
          <p className="text-xs text-brand-100 mt-1">
            התקן על מסך הבית שלך
          </p>
        )}
      </div>
      {!isIOS && (
        <button
          onClick={handleInstall}
          className="bg-white text-brand-600 px-3 py-1 rounded-lg text-sm font-bold"
        >
          התקן
        </button>
      )}
      <button onClick={() => setShowPrompt(false)}>
        <X className="w-5 h-5" />
      </button>
    </div>
  );
};

export default InstallPrompt;
